export default {
  // YouTube Link Generator
  'link.mainTitle': 'YouTubeタイムスタンプリンクジェネレーター',
  'link.mainTitleSEO': 'YouTubeタイムスタンプリンクジェネレーター - 共有可能な動画リンクを作成',
  'link.subtitle': '特定の時間から開始するYouTubeリンクを生成 - 共有に最適',

  // Link Generator Tool
  'link.generatorTitle': 'タイムスタンプ付きYouTubeリンクを作成',
  'link.pasteUrl': 'YouTube URLを貼り付け：',
  'link.urlPlaceholder': 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
  'link.startTime': '開始時間：',
  'link.hours': '時間',
  'link.minutes': '分',
  'link.seconds': '秒',
  'link.orEnterSeconds': 'または合計秒数を入力：',
  'link.secondsPlaceholder': '例：90',

  // Output Section
  'link.generatedLinks': '生成された共有可能なリンク：',
  'link.shortLink': '短いリンク（推奨）：',
  'link.fullLink': 'フルリンク：',
  'link.embedCode': '埋め込みコード：',
  'link.preview': 'プレビュー：',
  'link.copyLink': 'リンクをコピー',
  'link.copyEmbed': '埋め込みをコピー',

  // URL Formats
  'link.urlFormats': 'YouTubeタイムスタンプURL形式の説明',
  'link.format1Title': '1. クエリパラメータ形式（?t=）',
  'link.format1Desc': '任意のYouTube URLに?t=または&t=を追加：',
  'link.format1Example1': '?t=90 - 90秒（1分30秒）',
  'link.format1Example2': '?t=1m30s - 1分30秒',
  'link.format1Example3': '?t=1h5m30s - 1時間5分30秒',

  'link.format2Title': '2. ハッシュフラグメント形式（#t=）',
  'link.format2Desc': '#t=を使用する古い形式：',

  'link.format3Title': '3. モバイルアプリディープリンク',
  'link.format3Desc': 'モバイル共有用：',

  'link.format4Title': '4. 開始パラメータ付き埋め込みURL',
  'link.format4Desc': '埋め込み動画用：',

  // Use Cases
  'link.useCases': 'タイムスタンプリンクを使用する場合',
  'link.useCase1Title': '📱 ソーシャルメディア共有',
  'link.useCase1Desc': 'Twitter、Facebook、Redditで正確な瞬間を共有',

  'link.useCase2Title': '📧 メール参照',
  'link.useCase2Desc': '同僚をトレーニングビデオの特定の部分に送る',

  'link.useCase3Title': '📝 ブログ引用',
  'link.useCase3Desc': '記事の特定の動画証拠にリンク',

  'link.useCase4Title': '💬 フォーラム議論',
  'link.useCase4Desc': '動画討論の正確な瞬間を参照',

  'link.useCase5Title': '🎓 教育コンテンツ',
  'link.useCase5Desc': '生徒を特定のレッスンセグメントに誘導',

  'link.useCase6Title': '🎬 動画レビュー',
  'link.useCase6Desc': '特定のシーンや瞬間をハイライト',

  // FAQ
  'link.faq': 'YouTubeタイムスタンプリンク FAQ',

  'link.faq.q1': 'YouTubeタイムスタンプリンクはモバイルで動作しますか？',
  'link.faq.a1': 'はい！?t=と#t=の両方の形式がモバイルブラウザとYouTubeアプリで動作します。アプリがインストールされている場合はアプリで開き、そうでない場合はモバイルブラウザで開きます。',

  'link.faq.q2': '埋め込み動画でタイムスタンプリンクを使用できますか？',
  'link.faq.a2': 'はい、埋め込みURLでstart=パラメータを使用します：<iframe src="https://www.youtube.com/embed/VIDEO_ID?start=90"></iframe>',

  'link.faq.q3': 'タイムスタンプリンクはYouTube Shortsで動作しますか？',
  'link.faq.a3': 'いいえ、YouTube Shortsは現在タイムスタンプパラメータをサポートしていません。タイムスタンプリンクは通常のYouTube動画でのみ動作します。',

  'link.faq.q4': 'タイムスタンプリンクは常に動作しますか？',
  'link.faq.a4': 'はい、動画が公開されアクセス可能である限り、タイムスタンプリンクは引き続き動作します。動画が削除されたりプライベートにされた場合、リンクは動作しません。',

  'link.faq.q5': 'リンクに終了時間を追加できますか？',
  'link.faq.a5': 'はい、&end=パラメータを追加できます：?t=90&end=180は1:30から3:00まで再生されます',

  'link.faq.q6': 'どの形式を使用すべきですか - ?t=または#t=？',
  'link.faq.a6': '?t=（クエリパラメータ）形式を使用してください。これは最新の標準で、すべてのプラットフォームでより確実に動作します。#t=形式は古く、互換性が低いです。',

  // Related Tools
  'link.relatedTools': '関連YouTubeツール',
  'link.needChapters': '動画チャプターを作成する必要がありますか？',
  'link.needChaptersDesc': '動画説明とコメント用のチャプタータイムスタンプを作成するには、私たちのYouTubeタイムスタンプジェネレーターを使用してください。',
  'link.checkGenerator': 'YouTubeタイムスタンプジェネレーターをチェック',

  'link.needUnixTime': 'Unixタイムスタンプを扱っていますか？',
  'link.needUnixTimeDesc': '私たちのタイムスタンプコンバーターを使用して、Unixタイムスタンプを読みやすい日付に変換します。',

  // How to Use
  'link.howToUse': 'YouTubeタイムスタンプリンクの作成方法',
  'link.step1': 'YouTube動画URLをコピー',
  'link.step1Desc': 'ブラウザのアドレスバーまたは共有ボタンからURLを取得',

  'link.step2': '開始時間を入力',
  'link.step2Desc': 'タイムピッカーを使用するか、秒数を直接入力',

  'link.step3': '希望するリンク形式をコピー',
  'link.step3Desc': '短いリンク、フルリンク、埋め込みコードから選択',

  'link.step4': 'どこでも共有！',
  'link.step4Desc': 'ソーシャルメディア、メール、フォーラム、メッセージングアプリで動作',

  // Additional Tips
  'link.tips': 'プロのヒント',
  'link.tip1': '💡 ソーシャルメディアには短いリンク（youtu.be）を使用 - よりクリーンでスペースを取りません',
  'link.tip2': '💡 YouTube動画を右クリックして「現在の時刻の動画URLをコピー」を選択すると、すばやく共有できます',
  'link.tip3': '💡 タイムスタンプはプレイリストでも動作します：プレイリストURLに&t=90を追加するだけです',
  'link.tip4': '💡 プレイリスト用の&list=や&autoplay=1などの他のパラメータと組み合わせることができます',
};